/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'project-panel.generic-error.description': 'Zkontrolujte připojení k internetu a zkuste to znovu.',
  'project-panel.generic-error.title': 'Něco se pokazilo',
  'project-panel.project-icon-header.update-error-description':
    'Aktualizace ikony projektu {projectName} se nezdařila.',
  'project-panel.project-icon-header.update-error-title': 'Něco se pokazilo.',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'Zobrazit další pole',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': 'Zobrazit méně',
  'project-panel.project-panel-header.title': 'Projekt',
  'project-panel.project-panel-tabs.about-tab-title': 'Informace',
  'project-panel.project-panel-tabs.decisions-title': 'Rozhodnutí',
  'project-panel.project-panel-tabs.learnings-title': 'Vědomosti',
  'project-panel.project-panel-tabs.risks-title': 'Rizika',
  'project-panel.project-panel-tabs.updates-tab-title': 'Aktualizace',
  'project-panel.project-title.edit-button-label': 'Upravit název projektu',
  'project-panel.project-title.update-error-description': 'Aktualizace obsahu projektu {projectName} se nezdařila',
  'project-panel.project-title.update-error-title': 'Něco se pokazilo',
  'project-panel.project-title.validation-message': 'Zadejte název svého projektu.',
};
